import React from 'react'

export default function TextLoading(props) {
  return (
    <div className="animated fadeIn pt-3 text-center" {...props}>
      Đang tải...
    </div>
  )
}
